import React from 'react'

import { localizer } from '../../Translator'

import Button from '@material-ui/core/Button'
import Paper from '@material-ui/core/Paper'
import Grid from '@material-ui/core/Grid'
import Typography from '@material-ui/core/Typography'
import InputAdornment from '@material-ui/core/InputAdornment'

import { TextFieldLoginStyled } from "../common/InputStyled"

/**
 * Session initiation and status for a front-office user.
 */
export class LoginMfa extends React.Component {
  constructor(props) {
    super(props)
    this.state = {
      // Mfa code form field.
      mfaCode: '',
    }
  }

  // Controlled fields refresh.
  onChange = (event) => {this.setState({ [event.target.name]: event.target.value }) }

  render() {
    const buttonEnabled = !this.state.isLoading && this.state.mfaCode

    return (
      <React.Fragment>
        <Grid container direction="row" className="login-mfa-container" style={{ display: "block" }}>
          <Paper elevation={3} >
            <Grid container direction="row" className="p-10">

              {/* Title. */}
              <Grid item md={12}>
                <Typography className="typography-generic dialog-title" gutterBottom >{localizer.MfaTitle}</Typography>
                <Typography className="typography-generic" gutterBottom >{localizer.MfaInfo}</Typography>
              </Grid>
            
              {/* Verification code. */}
              <Grid item md={12}>
                <TextFieldLoginStyled
                  variant="outlined"
                  placeholder={localizer.MfaTitle}
                  name="mfaCode"
                  value={this.state.mfaCode}
                  onChange={(e) => { this.onChange(e) }}
                  fullWidth
                  inputRef={(input) => { if (input != null && this.focusOnCode) { input.focus(); this.focusOnCode = false } }}
                  InputProps={{
                    classes: {
                      input: "typography-generic"
                    },
                    startAdornment: (
                      <InputAdornment position="start">
                        <i className="fa-solid fa-shield" />
                      </InputAdornment>
                    ),
                  }}
                />
              </Grid>

              {/* Confirm mfa code button. */}
              <Grid item md={12}>
                <Button className="button-generic login mt-10"
                  variant="contained"
                  color="secondary"
                  fullWidth
                  disabled={!buttonEnabled}
                  onClick={() => {this.props.doLoginRequest(this.state.mfaCode)}}>
                  {localizer.Send}
                </Button>
              </Grid>
            </Grid>
          </Paper>
        </Grid>
       
      </React.Fragment>
    )
  }
}


// WEBPACK FOOTER //
// ./src/components/login/LoginMfa.js